<template>
  <Icon
    name="change"
    :width="18"
    :height="12"
  >
    <path d="M6.50817 7.6665H0.666504V9.33317H6.50817V11.8332L9.83317 8.49984L6.50817 5.1665V7.6665ZM11.4915 6.83317V4.33317H17.3332V2.6665H11.4915V0.166504L8.1665 3.49984L11.4915 6.83317Z"/>
  </Icon>
</template>

<script>
import Icon from "../Elements/Icon";
export default {
  name: "Change",

  components: { Icon },
};
</script>
